import { PropsWithChildren, useState } from 'react';

function SectionAccordion({
    title,
    children,
    ...props
}: PropsWithChildren<{ title: string; [key: string]: any }>) {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <div
            className={'product-parameters-item ui-accordion' + (isOpen ? ' ui-accordion--active' : '')}
            {...props}
        >
            <h2
                className="product-parameters-item__title ui-accordion__head"
                onClick={() => setIsOpen(!isOpen)}
            >
                {title}
            </h2>
            <div className="ui-accordion__body">{children}</div>
        </div>
    );
}

export default SectionAccordion;
